import React from 'react';

const TermsOfService = () => {
  return (
    <div className="page">
      <h1>Terms of Service</h1>
      {/* Content will be added later */}
    </div>
  );
};

export default TermsOfService; 